module.exports = __webpack_public_path__ + "img/fender-bender.4b593321.svg";